import { useEffect, useRef, useState } from "react";
import {
  encryptValue,
  saveInLocalStorage,
  titleCase,
} from "../../utilFunctions.js";
import { PAGE_NAME_KEYS, policyStatus } from "../../consts.js";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../reusableComponents/loader/loadingPage.jsx";
import MyWorkItemsFilter from "./MyWorkItemsFilter.jsx";
import MyWorkItemsSearch from "./MyWorkItemSearch.jsx";
import { getPortalNames } from "../apiHelper.js";
import {
  fetchClaimDetails,
  fetchClaimSearchfields,
  fetchPolicyStatusOptions,
} from "./apiHelper.js";

const MyWorkItems = (props) => {
  const { roleDataCookie, productNames } = props;
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [policyStatusOptions, setPolicyStatusOptions] = useState("");
  const [flaggedClaimsOptions, setFlaggedClaimsOptions] = useState([]);
  const [claimSubStatus, setClaimSubStatus] = useState([]);
  const navigate = useNavigate();
  const [claimslist, setClaimslist] = useState([]);
  const [searchResultMode, setSearchResultMode] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [portalList, setPortalList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [triggerAPi, setTriggerAPi] = useState(false);
  const scrollRef = useRef(null);
  useEffect(() => {
    getPolicyStatusOptions();
    getClaimSearchfields();
    getPortalNames({ setPortalList });
  }, []);
  const getClaimSearchfields = async () => {
    const data = await fetchClaimSearchfields(setLoading)
    const filteredData = data?.data?.filter(
      (list) => list && list !== "null"
    );
    setClaimSubStatus(
      filteredData.map((list) => {
        return {
          label: list,
          value: list,
        };
      })
    );
  };
  const getPolicyStatusOptions = async () => {
    setLoading(true);
    const data = await fetchPolicyStatusOptions(setLoading)
    const policyData = data?.data?.status?.flat("Infinity").map((list) => {
      return {
        label: titleCase(list),
        value: titleCase(list),
      };
    });
    setPolicyStatusOptions([...policyStatus, ...policyData]);
  };
  const getClaimDetails = async (claimno, navigation, setData) => {
    const data = await fetchClaimDetails(claimno, setLoading)
    let claimDetailsEncripted = encryptValue(JSON.stringify(data?.data));
    saveInLocalStorage("claimDetail", claimDetailsEncripted);
    navigation &&
      navigate(
        `/dashboard/${PAGE_NAME_KEYS.CLAIM_PROCESSING}/${PAGE_NAME_KEYS.CLAIM_INTIMATION_DETAILS}`
      );
    setData && setData(data?.data);
  };

  return (
    <section className="p-4">
      <h1 className="headerclaim">My Work Items</h1>
      <hr />
      <MyWorkItemsFilter
        productNames={productNames}
        selectedProducts={selectedProducts}
        setSelectedProducts={setSelectedProducts}
        setClaimslist={setClaimslist}
        claimSubStatus={claimSubStatus}
        policyStatusOptions={policyStatusOptions}
        flaggedClaimsOptions={flaggedClaimsOptions}
        setFlaggedClaimsOptions={setFlaggedClaimsOptions}
        setLoading={setLoading}
        selectedPage={selectedPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        setPageCount={setPageCount}
        setSelectedPage={setSelectedPage}
        setTotalRecords={setTotalRecords}
        setSearchResultMode={setSearchResultMode}
        scrollRef={scrollRef}
        triggerAPi={triggerAPi}
        userID={roleDataCookie?.userID}
      />
      <hr />
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="claim-historyclaim" ref={scrollRef}>
          {searchResultMode && claimslist?.length > 0 && (
            <h2 className="heading_h2" id="history">
              Search Results ({totalRecords})
            </h2>
          )}
          {loading ? (
            <LoadingPage />
          ) : (
            <MyWorkItemsSearch
              claimslist={claimslist}
              setClaimslist={setClaimslist}
              loading={loading}
              setLoading={setLoading}
              getClaimDetails={getClaimDetails}
              portalList={portalList}
              setItemsPerPage={setItemsPerPage}
              setSelectedPage={setSelectedPage}
              itemsPerPage={itemsPerPage}
              pageCount={pageCount}
              selectedPage={selectedPage}
              triggerAPi={triggerAPi}
              setTriggerAPi={setTriggerAPi}
            />
          )}
        </div>
      )}
    </section>
  );
};
export default MyWorkItems;
